import { useState } from 'react';
import PropTypes from 'prop-types';
import '../assets/assistantComponents.scss';

const AiAssistantDecisionActions = ({
  ariaLabel,
  actions,
  disabled = false,
}) => {
  const [activeAction, setActiveAction] = useState('');

  const runAction = async (action) => {
    if (disabled || activeAction || action.disabled) return;
    setActiveAction(action.key);
    try {
      await action.onClick?.();
    } finally {
      setActiveAction('');
    }
  };

  return (
    <div
      className={`ai-assistant-decision-actions has-${Math.min(actions.length, 3)}-actions`}
      aria-label={ariaLabel}
    >
      {actions.map((action) => (
        <button
          className={`btn btn-sm btn-${action.variant || 'outline-secondary'} ai-assistant-decision-button`}
          type="button"
          key={action.key}
          onClick={() => void runAction(action)}
          disabled={disabled || Boolean(activeAction) || action.disabled}
          aria-label={action.label}
          title={action.label}
        >
          {activeAction === action.key ? (
            <span className="spinner-border spinner-border-sm" aria-hidden="true"></span>
          ) : action.iconClass ? (
            <i className={`bi ${action.iconClass}`} aria-hidden="true"></i>
          ) : null}
          <span className="visually-hidden">{action.label}</span>
        </button>
      ))}
    </div>
  );
};

AiAssistantDecisionActions.propTypes = {
  ariaLabel: PropTypes.string.isRequired,
  actions: PropTypes.arrayOf(PropTypes.shape({
    key: PropTypes.string.isRequired,
    label: PropTypes.string.isRequired,
    iconClass: PropTypes.string,
    variant: PropTypes.string,
    onClick: PropTypes.func,
    disabled: PropTypes.bool,
  })).isRequired,
  disabled: PropTypes.bool,
};

export default AiAssistantDecisionActions;
